import React, {useContext} from 'react';
import css from './css/ViewAsComponent.module.css'
import useImpersonation from "../Hooks/useImpersonation";
import {Button, Col, Container, Row} from "react-bootstrap";
import {SalvoContext} from "../contexts/SalvoContext";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import ConditionalRender, {Fallback} from "./ConditionalRender";

const ViewAsComponent = () => {

    const { viewAs } = useImpersonation()
    const { setSelectedCompany, impersonatedUser, setImpersonatedUser } = useContext(SalvoContext)
    const {t} = useTranslation()
    const navigate = useNavigate();

    if(!viewAs)
        return null

    return (
        <div className={css.wrapper}>
            <Container>
                <Row>
                    <Col className='d-flex justify-content-center align-items-center'>
                        <span>{t('global.impersonation.impersonationViewing')} <strong>{viewAs.name}</strong></span>
                        <ConditionalRender condition={!impersonatedUser}>
                            <Button className='ms-2 text-uppercase' size='sm' variant='danger' onClick={() => {
                                setSelectedCompany(null);
                                navigate('/');
                            }}>{t('global.operations.exit')}</Button>

                            <Fallback>
                                <span>‎ as <strong>{impersonatedUser?.email}</strong></span>
                                <Button className='ms-2 text-uppercase' size='sm' variant='danger' onClick={() => {
                                    setImpersonatedUser(null);
                                }}>{t('global.operations.stop')}</Button>
                            </Fallback>
                        </ConditionalRender>

                        {/* <span className='' style={{marginLeft: '5px'}}>| {t("creditManagement.balance")} {balance}</span> */}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ViewAsComponent;